import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-f9ea2dfa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-sign-out-alt" }, null, -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Cerrar Sesión")
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check" }, null, -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Mejoras")
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-users" }, null, -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Usuarios")
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-columns" }, null, -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Dashboard")
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-box" }, null, -1))
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Productos")
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-phone" }, null, -1))
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Lista de Llamada")
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-invoice-dollar" }, null, -1))
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Reclamaciones")
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-users" }, null, -1))
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Empleados")
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-money-check-alt" }, null, -1))
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Cuentas por Cobrar")
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-money-check-alt" }, null, -1))
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Facturas")
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-users" }, null, -1))
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Ingresos Pediátricos")
const _hoisted_34 = [
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-users" }, null, -1))
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Consultorios")
const _hoisted_37 = [
  _hoisted_35,
  _hoisted_36
]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-users" }, null, -1))
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" Medicos")
const _hoisted_40 = [
  _hoisted_38,
  _hoisted_39
]
const _hoisted_41 = { class: "mycontainer" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "localIMG",
  src: _imports_0
}, null, -1))
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" Cruz ")
const _hoisted_44 = [
  _hoisted_42,
  _hoisted_43
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("nav", {
        class: _normalizeClass(_ctx.navMenuClas)
      }, [
        _createElementVNode("a", {
          style: {"color":"rgb(226, 165, 38)"},
          class: "navbar-option",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (this.hamburger('Cerrar Sesión'))),
          href: "#"
        }, _hoisted_4),
        (this.$store.state.user.type == 'Power User')
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "navbar-option",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (this.hamburger('Mejoras'))),
              href: "#"
            }, _hoisted_7))
          : _createCommentVNode("", true),
        (this.$store.state.user.type == 'Power User')
          ? (_openBlock(), _createElementBlock("a", {
              key: 1,
              class: "navbar-option",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (this.hamburger('Usuarios'))),
              href: "#"
            }, _hoisted_10))
          : _createCommentVNode("", true),
        (
            this.$store.state.user.type == 'Power User' ||
              this.$store.state.user.type == 'Administrador' ||
              this.$store.state.user.type == 'Presidente' ||
              this.$store.state.user.type == 'Médico Especialista'
          )
          ? (_openBlock(), _createElementBlock("a", {
              key: 2,
              class: "navbar-option",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (this.hamburger('Dashboard'))),
              href: "#"
            }, _hoisted_13))
          : _createCommentVNode("", true),
        (
            this.$store.state.user.type == 'Power User' ||
              this.$store.state.user.type == 'Administrador' ||
              this.$store.state.user.type == 'Presidente'
          )
          ? (_openBlock(), _createElementBlock("a", {
              key: 3,
              class: "navbar-option",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (this.hamburger('Productos'))),
              href: "#"
            }, _hoisted_16))
          : _createCommentVNode("", true),
        (
            this.$store.state.user.type == 'Power User' ||
              this.$store.state.user.type == 'Encargado' ||
              this.$store.state.user.type == 'Presidente' ||
              this.$store.state.user.type == 'Facturador' ||
              this.$store.state.user.type == 'Especialista' ||
              this.$store.state.user.type == 'Médico Especialista' ||
              this.$store.state.user.type == 'Director Médico' ||
              this.$store.state.user.type == 'Recepcionista'
          )
          ? (_openBlock(), _createElementBlock("a", {
              key: 4,
              class: "navbar-option",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (this.hamburger('Llamadas'))),
              href: "#"
            }, _hoisted_19))
          : _createCommentVNode("", true),
        (
            this.$store.state.user.type == 'Power User' ||
              this.$store.state.user.type == 'Encargado de Cuentas Médicas'
          )
          ? (_openBlock(), _createElementBlock("a", {
              key: 5,
              class: "navbar-option",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (this.hamburger('Reclamos'))),
              href: "#"
            }, _hoisted_22))
          : _createCommentVNode("", true),
        (
            this.$store.state.user.type == 'Power User'
             
          )
          ? (_openBlock(), _createElementBlock("a", {
              key: 6,
              class: "navbar-option",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (this.hamburger('Empleados'))),
              href: "#"
            }, _hoisted_25))
          : _createCommentVNode("", true),
        (
            this.$store.state.user.type == 'Power User' ||
              this.$store.state.user.type == 'Encargado'
          )
          ? (_openBlock(), _createElementBlock("a", {
              key: 7,
              class: "navbar-option",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (this.hamburger('Cxcs'))),
              href: "#"
            }, _hoisted_28))
          : _createCommentVNode("", true),
        (
            this.$store.state.user.type == 'Power User' 
             
          )
          ? (_openBlock(), _createElementBlock("a", {
              key: 8,
              class: "navbar-option",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (this.hamburger('Facturaas'))),
              href: "#"
            }, _hoisted_31))
          : _createCommentVNode("", true),
        (
            this.$store.state.user.type == 'Power User' ||
              this.$store.state.user.type == 'Médico Especialista' ||
              this.$store.state.user.type == 'Administrador'
          )
          ? (_openBlock(), _createElementBlock("a", {
              key: 9,
              class: "navbar-option",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (this.hamburger('IngresosPediatricos'))),
              href: "#"
            }, _hoisted_34))
          : _createCommentVNode("", true),
        (
            this.$store.state.user.type == 'Power User' ||
            this.$store.state.user.type == 'Encargado' ||
              
        
             
              this.$store.state.user.type == 'Agente'
              

              
          )
          ? (_openBlock(), _createElementBlock("a", {
              key: 10,
              class: "navbar-option",
              onClick: _cache[11] || (_cache[11] = ($event: any) => (this.hamburger('Consultorios'))),
              href: "#"
            }, _hoisted_37))
          : _createCommentVNode("", true),
        (
           this.$store.state.user.type == 'Power User' ||
              this.$store.state.user.type == 'Director Médico'
          )
          ? (_openBlock(), _createElementBlock("a", {
              key: 11,
              class: "navbar-option",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (this.hamburger('Medicos'))),
              href: "#"
            }, _hoisted_40))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("nav", null, [
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("a", {
            class: "item navbar-brand",
            onClick: _cache[13] || (_cache[13] = ($event: any) => (this.$router.push(`/dashboard`))),
            href: "#"
          }, _hoisted_44),
          _createElementVNode("a", {
            class: "item navbar-brand userName",
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.hamburger())),
            href: "#"
          }, [
            _createTextVNode(_toDisplayString(this.$store.state.user.usuario) + " ", 1),
            _createElementVNode("i", {
              class: _normalizeClass(_ctx.desplegar)
            }, null, 2)
          ])
        ])
      ])
    ])
  ]))
}